import { BodyText } from "@/components/ui";
import { formatDateTime } from "@/lib/time";
import type { Goal as GoalResource } from "@curai/js-fhir-tools";

interface GoalProps {
  goal: GoalResource;
}

export const Goal = ({ goal }: GoalProps) => {
  return (
    <div className="flex relative flex-col gap-1 py-2 w-full">
      <BodyText size="sm">{goal.descriptionDisplay}</BodyText>
      {goal.statusDate && (
        <BodyText size="xs" textColor="tertiary" italic>
          Added {formatDateTime(goal.statusDate)}
        </BodyText>
      )}
    </div>
  );
};
